document.addEventListener('DOMContentLoaded', function() {
  const section = document.getElementById('features-slider');
  if (!section) return;

  const slides = section.querySelectorAll('.features-slider__slide');
  const slidesMobile = section.querySelectorAll('.features-slider__slide-mobile');
  const prevBtn = section.querySelector('.features-slider__arrow--prev');
  const nextBtn = section.querySelector('.features-slider__arrow--next');
  const currentSpan = section.querySelector('.features-slider__current');
  const slideInner = section.querySelectorAll('.features-slider__panel-inner');
  const dividerItems = section.querySelectorAll('.features-slider__divider-item');
  
  const totalSlides = slides.length;
  let currentIndex = 0;
  const mobileBreakpoint = 900;

  function isMobile() {
    return window.innerWidth <= mobileBreakpoint;
  }

  function updateSlide(newIndex) {
    // On mobile, disable loop/circular navigation
    if (isMobile()) {
      if (newIndex < 0) newIndex = 0;
      if (newIndex >= totalSlides) newIndex = totalSlides - 1;
    } else {
      if (newIndex < 0) newIndex = totalSlides - 1;
      if (newIndex >= totalSlides) newIndex = 0;
    }
    
    slides.forEach((slide, index) => {
      slide.classList.toggle('active', index === newIndex);
    });
    
    slidesMobile.forEach((slide, index) => {
      slide.classList.toggle('active', index === newIndex);
    });
    
    slideInner.forEach((inner, index) => {
      inner.classList.toggle('active', index === newIndex);
    });
    
    dividerItems.forEach((item, index) => {
      item.classList.toggle('active', index === newIndex);
    });
    
    currentIndex = newIndex;
    
    // Update all pagination displays
    section.querySelectorAll('.features-slider__current').forEach(span => {
      span.textContent = currentIndex + 1;
    });

    // Update button disabled states on mobile
    updateButtonStates();
  }

  function updateButtonStates() {
    if (isMobile()) {
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
        prevBtn.classList.toggle('disabled', currentIndex === 0);
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex === totalSlides - 1;
        nextBtn.classList.toggle('disabled', currentIndex === totalSlides - 1);
      }
    } else {
      // Enable all buttons on desktop
      if (prevBtn) {
        prevBtn.disabled = false;
        prevBtn.classList.remove('disabled');
      }
      if (nextBtn) {
        nextBtn.disabled = false;
        nextBtn.classList.remove('disabled');
      }
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      // Prevent navigation if disabled
      if (isMobile() && currentIndex === 0) return;
      updateSlide(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      // Prevent navigation if disabled
      if (isMobile() && currentIndex === totalSlides - 1) return;
      updateSlide(currentIndex + 1);
    });
  }

  // Update button states on window resize
  window.addEventListener('resize', updateButtonStates);
  
  // Initialize button states
  updateButtonStates();

  // Touch/swipe support for mobile with direction lock
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let isHorizontalSwipe = null; // null = not determined, true = horizontal, false = vertical
  const directionLockThreshold = 10; // pixels to determine swipe direction

  section.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchEndX = touchStartX;
    isHorizontalSwipe = null; // Reset direction lock
  }, { passive: true });

  section.addEventListener('touchmove', (e) => {
    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const diffX = Math.abs(currentX - touchStartX);
    const diffY = Math.abs(currentY - touchStartY);

    // Determine swipe direction if not yet determined
    if (isHorizontalSwipe === null && (diffX > directionLockThreshold || diffY > directionLockThreshold)) {
      isHorizontalSwipe = diffX > diffY;
    }

    // If horizontal swipe is detected, prevent vertical scrolling
    if (isHorizontalSwipe === true) {
      e.preventDefault();
    }

    touchEndX = currentX;
  }, { passive: false }); // passive: false is required to call preventDefault()

  section.addEventListener('touchend', (e) => {
    if (isHorizontalSwipe === true) {
      handleSwipe();
    }
  }, { passive: true });

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - go to next slide
        // On mobile, prevent if at last slide
        if (isMobile() && currentIndex === totalSlides - 1) return;
        updateSlide(currentIndex + 1);
      } else {
        // Swipe right - go to previous slide
        // On mobile, prevent if at first slide
        if (isMobile() && currentIndex === 0) return;
        updateSlide(currentIndex - 1);
      }
    }
  }
  
  class FeaturesSliderAnimation extends HTMLElement {
    constructor() {
      super();
      this.textRevealAnimationNodes = this.querySelectorAll('text-reveal-animation.animated-text-container');
      this.triggerElementClassName = this.getAttribute('trigger-element');
      this.observer = null;
      this.hasTriggered = false;
    }
    
    connectedCallback() {
      this.initIntersectionObserver();
    }
    
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
    
    initIntersectionObserver() {
      const triggerElement = document.querySelector(`.${this.triggerElementClassName}`);
      if (!triggerElement) return;
      
      // triggerHook: 0.8 相当于元素进入视口 20% 时触发 (rootMargin: '-20% 0px')
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasTriggered) {
            this.hasTriggered = true;
            
            // 添加 active 类
            triggerElement.classList.add('active');
            
            // 播放文字动画
            if (this.textRevealAnimationNodes.length > 0) {
              this.textRevealAnimationNodes.forEach(node => {
                node.play();
              });
            }
            
            // 只触发一次，之后停止观察
            this.observer.unobserve(triggerElement);
          }
        });
      }, {
        threshold: 0,
        rootMargin: '-20% 0px 0px 0px' // 相当于 triggerHook: 0.8
      });
      
      this.observer.observe(triggerElement);
    }
  }
  
  customElements.define('features-slider-animation', FeaturesSliderAnimation);
});